import {listItemButtonClasses, ThemeOptions, Breakpoints} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiSideNavigation = ({focus, subnav}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => {
  return {
    MuiList: {
      styleOverrides: {
        root: {
          '&.sideNavigation-list': {
            borderWidth: 0,
            borderStyle: 'solid',
            borderColor: subnav.divider.desktop.background.color,
            [mediaQueries.up('md')]: {
              '&.sideNavigation-left': {
                borderRightWidth: 1
              },
              '&.sideNavigation-right': {
                borderLefttWidth: 1
              }
            }
          }
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {}
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.sideNavigation-listItemButton': {
            borderWidth: 0,
            borderLeftWidth: subnav.desktop.selected.pipe.width,
            borderLeftStyle: 'solid',
            borderColor: 'transparent',
            display: 'block',
            padding: subnav.desktop.padding.all,
            '> div': {
              padding: subnav.desktop.padding.all
            },
            [`&.${listItemButtonClasses.selected}`]: {
              borderWidth: 0,
              borderLeftStyle: 'solid',
              borderLeftColor: '#4B4D4F',
              borderLeftWidth: subnav.desktop.selected.pipe.width,
              backgroundColor: 'transparent',
              '&.Mui-focusVisible': {
                borderLeftColor: subnav.desktop.selected.pipe.background.color
              }
            },
            '&:hover': {
              backgroundColor: 'transparent'
            },
            '&:hover > div': {
              backgroundColor: subnav.desktop.hover.background.color,
              borderRadius: subnav.desktop.hover.border.radius
            },
            [`&.${listItemButtonClasses.focusVisible}`]: {
              backgroundColor: 'transparent',
              outline: 'none',
              '& > div': {
                outlineWidth: focus.outline.width,
                outlineStyle: focus.outline.style,
                outlineColor: focus.outline.color
              }
            },
            '.sideNavigation-title': {
              color: subnav.title.desktop.font.color,
              fontSize: subnav.title.desktop.font.size,
              fontWeight: subnav.title.desktop.font.weight,
              lineHeight: subnav.title.desktop.font.lineHeight,
              '&:hover': {
                textDecoration: subnav.title.desktop.hover.textDecoration
              },
              [mediaQueries.down('sm')]: {
                fontSize: subnav.title.mobile.font.size,
                fontWeight: subnav.title.mobile.font.weight,
                lineHeight: subnav.title.mobile.font.lineHeight
              }
            },
            '.sideNavigation-title-selected': {
              color: subnav.title.desktop.selected.font.color
            },
            '.sideNavigation-description': {
              color: subnav.description.desktop.font.color,
              fontSize: subnav.description.desktop.font.size,
              fontWeight: subnav.description.desktop.font.weight,
              lineHeight: subnav.description.desktop.font.lineHeight,
              [mediaQueries.down('sm')]: {
                fontSize: subnav.description.mobile.font.size,
                fontWeight: subnav.description.mobile.font.weight,
                lineHeight: subnav.description.mobile.font.lineHeight
              }
            }
          }
        }
      }
    }
  };
};
